export const classes = {
  active: 'active',
  button: 'button',
  buttonLoading: 'button--loading',
  complete: 'complete',
  flexPanel: 'leadform-panel--flex',
  formField: 'form-field',
  formFieldErrorTag: 'form-field__error-tag',
  formFieldError: 'form-field__error',
  formFieldInputError: 'form-field__input--error',
  formFieldValidated: 'form-field--validated',
  formTutoringJobs: 'form-wizard--tutoring-jobs',
  validatedInput: 'js-input-validated'
};

export const selectors = {
  active: `.${classes.active}`,
  action: '.form-wizard-action',
  actionFormOption: '.form-wizard-action[data-action-name=form-option]',
  actionGoTo: '.form-wizard-action[data-action-name=go-to]',
  actionRedirect: '.form-wizard-action[data-action-name=redirect]',
  actionSubmitForm: '.form-wizard-action[data-action-name=submit-form]',
  activePanel: '.leadform-panel.active',
  autoFocusFields: ['[type=text]', '[type=email]', '[type=tel]', 'textarea'],
  backButton: '.js-leadform-back, [data-trigger=back]',
  buttonLoading: `.${classes.buttonLoading}`,
  completePanel: '.leadform-panel.complete',
  complete: `.${classes.complete}`,
  checkboxesField: '.form-field--type-checkboxes',
  education_consultant: '.education-consultant-wrapper',
  fields: ['input', 'select', 'textarea'],
  flexPanel: `.${classes.flexPanel}`,
  flexPanelInterstitial: `.${classes.flexPanel}[data-panel-type="form_wizard/panel_interstitial"]`,
  form: 'form.form--form-wizard',
  formField: `.${classes.formField}`,
  formFieldError: `.${classes.formFieldError}`,
  formFieldLabel: '.form-field__label',
  fullNameField: '.form-field--full-name',
  interpolation: '.interpolation',
  formFieldErrorTag: `.${classes.formFieldErrorTag}`,
  leadform: '.leadform.leadform--wizard',
  multipleChoicePanel: '.leadform-panel[data-panel-type="form_wizard/panel_multiple_choice"]',
  // TODO: work towards deprecating js classes in favor of data-trigger
  nextButton: '.js-leadform-next, [data-trigger=next]',
  panel: '.leadform-panel',
  step: '.leadform-panel, .form-wizard-action',
  panels: '.form-wizard-panels',
  panelInterstitial: '.panel-interstitial',
  phoneNumberField: '.form-field--phone-number',
  progressBarIndicator: '.progress-bar__indicator',
  progressBarText: '.progress-bar__text',
  wrapper: '.js-leadform',
  zipCodeField: '.form-field--zip-code'
};

export const actions = {
  redirect: 'redirect',
  submitForm: 'submit-form',
  goTo: 'go-to',
  formOption: 'form-option'
};

export const datoNonTextInputTypes = ['checkbox', 'radio'];
